import { Box, Link, Typography } from "@mui/material";
import { normalizeHttpUrl } from "../utils/allianceQuickLinks";

export interface LinkItem {
  title?: string;
  link?: string;
}

interface LinkListProps {
  items: LinkItem[];
  /** Global index prvog zapisa na ovoj stranici (Za stabilne ključeve pri paginaciji). */
  firstIndex?: number;
}

export function LinkList({ items, firstIndex = 0 }: LinkListProps) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {items.map((item, i) => {
        const stableKey =
          item.link ??
          `${item.title ?? ""}-${firstIndex + i}-${String(item.title ?? "")}`;
        if (!item.link && !item.title) return null;
        if (!item.link) {
          return (
            <Typography key={stableKey} variant="body2">
              {item.title}
            </Typography>
          );
        }
        return (
          <Link
            key={stableKey}
            href={normalizeHttpUrl(String(item.link))}
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
          >
            {item.title || item.link}
          </Link>
        );
      })}
    </Box>
  );
}
